import React, { useState, useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import {
  Link,
  SpacingVertical,
  SPACING_8,
  Flex,
  FlexItem
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { MIN_ITEMS_IN_DETAILS, RESPONSE_CODE } from '../const'

const StyledUl = styled.ul`
  list-style-type: circle;
  margin-left: 20px;
  margin-top: 8px;
`

const StyledLiItem = styled.li`
  word-break: break-all;
`

const Details = ({ detailArray, detailCode, index }) => {
  const [showAll, setShowAll] = useState(false)
  const intl = useIntl()

  const responseCode = useMemo(
    () => RESPONSE_CODE.find(e => e.code === detailCode),
    [detailCode]
  )

  const getDetailArray = () => {
    return showAll ? detailArray : detailArray.slice(0, MIN_ITEMS_IN_DETAILS)
  }
  return (
    <>
      <SpacingVertical variant={SPACING_8} />
      <div key={index}>
        {intl.formatMessage(
          {
            id: responseCode.lang_id
          },
          {
            FILENAME: detailArray && detailArray.length > 0 && detailArray[0]
          }
        )}
        {responseCode.details && detailArray && detailArray.length > 0 && (
          <>
            <StyledUl>
              {getDetailArray().map((e, i) => (
                <StyledLiItem key={i}>{e}</StyledLiItem>
              ))}
            </StyledUl>
            {detailArray.length > MIN_ITEMS_IN_DETAILS && (
              <Flex margin='8px 0 0 16px'>
                <FlexItem>
                  <Link
                    href='#'
                    onClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                      setShowAll(!showAll)
                    }}
                  >
                    {!showAll
                      ? intl.formatMessage({ id: 'Load.Common.ShowAll' })
                      : intl.formatMessage({ id: 'Load.Common.ShowLess' })}
                  </Link>
                </FlexItem>
              </Flex>
            )}
          </>
        )}
      </div>
    </>
  )
}

Details.propTypes = {
  detailArray: PropTypes.array,
  detailCode: PropTypes.number,
  index: PropTypes.number
}

export default Details
